const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @actions
const cardStatementMovementsActions = require('actions/cardStatementMovements');

// @components
const CardStatementMovements = require('components/cards/cardStatementMovements/cardStatementMovements');
const CardStatementMoreOptionsButton = require('components/cards/cardStatementMoreOptionsButton/cardStatementMoreOptionsButton');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @utilities
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');

// @constants
const { DATE_FORMAT_FULL_MONTH_YEAR } = require('constants/index');

class CardStatementMovementsView extends React.Component {
    componentDidMount() {
        const { history, match: { params: { cardId, statementId } }, requestMovements, immCards } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_STATEMENT_MOVEMENTS, { immCard }, history);
        requestMovements(cardId, statementId);
    }

    buildHeaderSubPage() {
        const { match: { params: { cardId, statementId } }, immCards, immCardsStatementDetails } = this.props;
        const immStatementDetails = immCardsStatementDetails.getIn([statementId, 'details']);
        let headerSubPage = <LoadingSection />;

        if (immStatementDetails) {
            const immCard = immCards.getIn(['byId', cardId]);
            const date = DateHelper.buildFormattedDate(immStatementDetails.get('date'), DATE_FORMAT_FULL_MONTH_YEAR);
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('cardStatement-statements'),
                    url: `/myprofile/cards/${cardId}/statements`
                },
                {
                    text: date
                }
            ];

            headerSubPage = (
                <OKHeaderSubPage breadcrumbConfig={mappingBreadcrumb}
                    subtitleLeft={subtitleLeft}
                    subtitleRight={subtitleRight}
                    finalTitle={getFinalTitle('cardStatement-movementsTitle', [date])}>
                    <CardStatementMoreOptionsButton immCard={immCard} statementId={statementId} />
                </OKHeaderSubPage>
            );
        }

        return headerSubPage;
    }

    render() {
        const { match: { params: { statementId } }, immScreen, immStatementMovements, requestMovements, requestNextPage } = this.props;
        const immMovements = immStatementMovements.get(statementId);
        const headerSubPage = this.buildHeaderSubPage();
        let mainComponent;

        if (!!immMovements) {
            mainComponent = (
                <CardStatementMovements
                    requestMovements={requestMovements}
                    requestNextPage={requestNextPage}
                    immMovements={immMovements}
                    immScreen={immScreen}
                    statementId={statementId}
                />
            );
        }

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="cards" customClass="col-xs-12">
                            {headerSubPage}
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                {mainComponent}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CardStatementMovementsView.propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardsStatementDetails: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    immStatementMovements: PropTypes.object.isRequired,
    requestMovements: PropTypes.func.isRequired,
    requestNextPage: PropTypes.func.isRequired
};

module.exports.constructor = CardStatementMovementsView;
module.exports.CardStatementMovementsView = connect(
    state => ({
        immCards: state.cards,
        immCardsStatementDetails: state.cardsStatementDetails,
        immScreen: state.screen,
        immStatementMovements: state.cardsStatementMovements,
    }), {
    requestMovements: cardStatementMovementsActions.requestMovements,
    requestNextPage: cardStatementMovementsActions.requestNextPage
}
)(withRouter(CardStatementMovementsView));
